// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const getInitialCommentValues = () => (dispatch, getState) => {
  const { user } = getState()

  return {
    comment: '',
    commentDate: Date.now(),
    createUserId: user.get('userId'),
    files: [],
    userName: user.get('userName'),
  }
}

export default getInitialCommentValues
